import React from 'react';
import { Container, Typography, Box } from '@mui/material';

export default function About() {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight="bold" gutterBottom textAlign="center">About GrandStays</Typography>
      <Typography variant="body1" paragraph sx={{ mt: 3, color: '#475569', lineHeight: 1.8 }}>
        Founded in 2020, GrandStays connects travelers with unforgettable luxury accommodations across the globe. From beachfront resorts in Hawaii to cozy alpine lodges in Aspen, we handpick every property to guarantee top-tier comfort, service, and design.
      </Typography>
    </Container>
  );
}